<!-- 📁 src/components/InfoBox.vue -->
<template>
  <a v-if="isDisabled" :href="value" target="_blank" class="info-box-link">
    <div v-if="isDisabled" class="info-box">
      <i :class="icon"></i>
      <strong>{{ label }}</strong>
    </div>
  </a>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: null },
    icon: { type: String, default: "fa-solid fa-info-circle" } // Icono por defecto
  },
  computed:{
    isDisabled(){
      return this.value;
    }
  }
};
</script>

<style scoped>
.info-box-link {
  text-decoration: none;
  color: inherit;
  display: block; /* Hace que el <a> envuelva toda la caja */
}

.info-box {
  background: #f8f8f8;
  padding: 12px;
  border-radius: 6px;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 14px;
  min-height: 60px;
  transition: background 0.2s;
}

.info-box:hover {
  background: #ececec;
  cursor: pointer;
}

.info-box i {
  color: #5b5b5b;
  font-size: 20px;
}

.info-box strong {
  color: #333;
  font-weight: 500;
}

</style>

